import { NgClass, SlicePipe } from '@angular/common';
import { Component, input, ViewEncapsulation } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { SheetModule } from '@valk-nx/components/ui-sheet/src/lib/sheet.module';
import { HeadingDirective } from '@valk-nx/core/lib/directives/heading/heading.directive';
import type { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	encapsulation: ViewEncapsulation.None,
	imports: [
		SVG_ICON_IMPORTS,
		HeadingDirective,
		NgClass,
		SlicePipe,
		TranslatePipe,
		SheetModule,
	],
	host: { ngSkipHydration: 'true' },
	selector: 'vp-list-grid',
	templateUrl: './list-grid.html',
})
export class ListGridComponent {
	name = input.required<string>();
	listItems = input.required<string[]>();

	sheetTitle = input<string>();
	title = input<string>();
	useCol2 = input<boolean>(true);
	headingType = input<HeadingType>('h3');
}
